import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressWishlistWishlistUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'bo._base_domain_': [
      {
        srcPath: '/wishlist-server',
        destPath: '',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/wishlist-server',
        destPath: '',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/wishlist-server',
        destPath: '',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/wishlist-server',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_api/wishlist-server',
        destPath: '',
      },
    ],
    'ecom._base_domain_': [
      {
        srcPath: '/_api/wishlist-server',
        destPath: '',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/wishlist-server',
        destPath: '/api',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/wishlist-server',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/stores/v1/wishlists',
        destPath: '/v1/wishlists',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/wishlist-server',
        destPath: '',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/wishlist-server',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/wishlist-server',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/wishlist-server',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_stores_wishlist';

/** Get wishlist by id */
export function getWishlistById(payload: object): RequestOptionsFactory<any> {
  function __getWishlistById({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.platform.v1.wishlist',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.wishlist.Wishlist.GetWishlistById',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressWishlistWishlistUrl({
        protoPath: '/v1/wishlists/get',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [{ path: 'wishlist.items.dateAdded' }],
          },
        ]),
    };

    return metadata;
  }

  return __getWishlistById;
}
